enum HgListingVideoMovieTypes {
  YOUTUBE,
  VIMEO,
}

const youtubeRegex =
  /(?:https?:\/\/)?(?:www\.)?youtu\.?be(?:\.com)?\/?.*(?:watch|embed)?(?:.*v=|v\/|\/)([\w\-_]+)&?/;
const vimeoRegex =
  /(?:https?:\/\/)?(?:www\.)?(?:player\.)?vimeo\.com\/(?:video\/)?(\d+)(?:[?&#].*)?$/;

export const isYouTubeVideoUrl = (src: string): boolean => {
  return youtubeRegex.test(src);
};

export const isVimeoVideoUrl = (src: string): boolean => {
  return vimeoRegex.test(src);
};

export const isVideoMovieUrl = (src: string): boolean => {
  return isYouTubeVideoUrl(src) || isVimeoVideoUrl(src);
};

export const getEmbeddedYouTubeUrl = (src: string, locale: string): string | undefined => {
  if (!isYouTubeVideoUrl(src)) {
    return;
  }

  const youtubeMatch = src.match(youtubeRegex) ?? [];
  const urlParams = [
    'autoplay=0',
    'start=0',
    'loop=0',
    'rel=0',
    `playlist=${youtubeMatch[1]}`,
    'showinfo=0',
    `hl=${locale}`,
  ];

  return `https://www.youtube-nocookie.com/embed/${youtubeMatch[1]}?${urlParams.join('&')}`;
};

export const getEmbeddedVimeoUrl = (src: string): string | undefined => {
  if (!isVimeoVideoUrl(src)) {
    return;
  }

  const vimeoMatch = src.match(vimeoRegex) ?? [];
  const videoId = vimeoMatch[1];

  if (!videoId) {
    return;
  }

  const urlParams = ['autoplay=0', 'title=0', 'byline=0', 'portrait=0', 'dnt=1'];

  return `https://player.vimeo.com/video/${videoId}?${urlParams.join('&')}`;
};

export const getEmbeddedVideoUrl = (src: string, locale: string): string | undefined => {
  if (isYouTubeVideoUrl(src)) {
    return getEmbeddedYouTubeUrl(src, locale);
  }

  if (isVimeoVideoUrl(src)) {
    return getEmbeddedVimeoUrl(src);
  }
};

interface HgListingVideoMovie {
  src?: string;
  label?: string;
  title?: string;
}

export { HgListingVideoMovie, HgListingVideoMovieTypes };
